// extracted by mini-css-extract-plugin
module.exports = {"loadingPage":"LoadingContent_loadingPage__Tslu_","loadingContent":"LoadingContent_loadingContent__UpR6q"};